import { Injectable } from '@angular/core';
import { RxapDataSource } from 'eurogard-data-source';
import { GetByFilterToTableMethod } from './get-by-filter-to-table.method';
import { DynamicTableDataSource } from 'eurogard-data-source/table';
import { TypedDashboard } from './typed.dashboard';
import { TypedDashboardTableMethod } from './typed-dashboard-table.method';

@Injectable()
@RxapDataSource('typed-dashboard-table')
export class TypedDashboardTableDataSource extends DynamicTableDataSource<TypedDashboard> {

  constructor(
    getByFilter: TypedDashboardTableMethod,
  ) {
    super(new GetByFilterToTableMethod(getByFilter));
  }

}
